export const zIndex = {
  floatingButton: 400,
  fixedButton: 900,
  dropdown: 1000,
  modal: 1010,
};
